 
<template>
  <div class="manage-waste-wrap">
    <!-- <div class="loader" v-if="isLoading">
      <CSpinner variant="grow" />
    </div> -->
    <!-- <CCardHeader>
	<CButton color="primary" class="px-4" @click="add()">Add waste</CButton>
	</CCardHeader> -->
    <CRow class="justify-content-around">
      <CCol sm="5">
        <div class="custom-col-left-wrap">
          <div class="cirlce-icon-wrap">
            <img src="../../assets/icons/arrow.svg" alt="circle" />
          </div>
          <div class="content-data">
            <h3>
              {{
                requestData &&
                requestData.vehicleStatus &&
                requestData.vehicleStatus.iN_TRANSIST
                  ? requestData.vehicleStatus.iN_TRANSIST
                  : "0"
              }}
            </h3>
            <p>Active</p>
          </div>
        </div>
      </CCol>
      <CCol sm="5">
        <div class="custom-col-right-wrap">
          <div class="cirlce-icon-wrap">
            <img src="../../assets/icons/arrow.svg" alt="circle" />
          </div>
          <div class="content-data">
            <h3>
              {{
                requestData &&
                requestData.requestStatus &&
                requestData.requestStatus.pending
                  ? requestData.requestStatus.pending
                  : "0"
              }}
            </h3>
            <p>Pending</p>
          </div>
        </div>
      </CCol>
    </CRow>
    <div class="table-top-header">
      <h3>Waste Lifting Request List</h3>
      <CButton
        class="px-4 add-waste-btn"
        @click="add()"
        :class="addcondition ? '' : 'hidden'"
        ><img src="../../assets/icons/plus.svg" alt="Plus" />Add Waste</CButton
      >
    </div>
    <div class="card-wrap">
      <CCardHeader class="waste-header">
        <slot name="header">
          <!--<span><CIcon name="cil-grid" class="mr-2"/> {{caption}}</span>-->
          <CRow>
            <CCol sm="4">
              <CInput
                label="From Date"
                type="date"
                :value="clientvise_fromdate_value"
                id="clientvise_fromdate"
                @input="dateFilter_client"
              />
            </CCol>
            <CCol sm="4">
              <CInput
                label="To Date"
                type="date"
                :value="sitevise_todate_value"
                id="clientvise_todate"
                @input="dateFilter_client"
              />
            </CCol>
            <CCol sm="4">
              <CSelect
                label="Site"
                :options="plantcodeOptions"
                id="plantcodeOptions"
                placeholder="Select Site"
                :value.sync="selectedPantCode"
                v-on:change="getShuffledWasteDataFilter()"
              />
            </CCol>
          </CRow>
        </slot>
      </CCardHeader>
      <CRow>
        <CCol sm="12">
          <CTableWrapper
            :items="items"
            hover
            striped
            bordered
            small
            fixed
            caption="Waste list"
          />
        </CCol>
      </CRow>
    </div>
  </div>
</template>

<script>
import CTableWrapper from "./Manage_waste.vue";
//import usersData from '../manage_waste/UsersData'
import axios from "axios";
export default {
  name: "Manage_wastes",
  data() {
    return {
      isLoading: false,
      plantcodeOptions: [],
      siteArr: [],
      Plant_Code: 0,
      items: [],
      addcondition: "",
      clientvise_fromdate_value: "",
      sitevise_todate_value: "",
      selectedPantCode: null,
      requestData: {},
    };
  },
  props: {
    caption: {
      type: String,
      default: "Waste Request List",
    },
  },
  components: { CTableWrapper },
  mounted() {
    var self = this;
    self.fnGetWastList();
    var d = new Date();
    var month = d.getMonth() + 1;
    var day = d.getDate();

    var today =
      d.getFullYear() +
      "-" +
      (month < 10 ? "0" : "") +
      month +
      "-" +
      (day < 10 ? "0" : "") +
      day;
    self.sitevise_todate_value = today;

    d.setDate(d.getDate() - 7);
    var month = d.getMonth() + 1;
    var day = d.getDate();

    var firstdate =
      d.getFullYear() +
      "-" +
      (month < 10 ? "0" : "") +
      month +
      "-" +
      (day < 10 ? "0" : "") +
      day;
    self.clientvise_fromdate_value = firstdate;

    var app_roleId = JSON.parse(localStorage.getItem("app_roleId"));
    if (app_roleId == "1") {
      self.addcondition = "1";
    } else {
      var userRules = JSON.parse(localStorage.getItem("RoleWiseModules"));
      var modulefind = userRules.find(function (jsonitem, f) {
        if (jsonitem.Slug == "add_waste") {
          self.addcondition = "1";
        }
      });
    }
    var token = localStorage.getItem("auth");
    var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
    var requestInfo = {
      Token: token,
      Session_User_Id: Session_User_Id,
    };
    var data = JSON.stringify(requestInfo);
    var config = {
      method: "post",
      url: apiURL + "MasterData/GetSapSites",
      headers: {
        "Content-Type": "application/json",
      },
      data: data,
    };
    this.isLoading = true;
    axios(config).then((result) => {
      if (result.data.status_code == 200) {
        var obj = result.data.response;
        var siteOptionsArr = obj;

        this.siteArr = obj;
        var siteSingleArr = [];
        var selArr = siteOptionsArr.find(function (jsonitem, i) {
          siteSingleArr.push(jsonitem.Plant_Name);
        });
        this.plantcodeOptions = siteSingleArr;

        var self1 = self;
        self1.selectedPantCode = siteOptionsArr[0].Plant_Name;
        var firstdate = $("#sitevise_fromdate").val();
        var today = $("#sitevise_todate").val();
        var token = localStorage.getItem("auth");
        var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));

        // for dashboard Api call
        var Plant_Code = siteOptionsArr[0].Plant_Code;
        const requestPaymentInfo = {
          customerID: Session_User_Id,
          plantCode: siteOptionsArr[0].Plant_Code,
          type: "Summary",
          fromDate: self1.clientvise_fromdate_value,
          toDate: self1.sitevise_todate_value,
        };
        var DashBoardInfodata = JSON.stringify(requestPaymentInfo);
        const newConfig = {
          method: "POST",
          url: apiURL + "Customer/DashBoardInfo",
          headers: { "Content-Type": "application/json" },
          data: DashBoardInfodata,
        };

        this.isLoading = true;
        axios(newConfig)
          .then((result) => {
            this.requestData = result.data.response;
            // for Ageing chart---------------------------------------
            this.isLoading = false;
          })
          .catch((error) => {
            this.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
          });

        // for wastrequest data
        var requestInfo = {
          Token: token,
          RequestFromDate: self1.clientvise_fromdate_value,
          RequestToDate: self1.sitevise_todate_value,
          Session_User_Id: Session_User_Id,
          // Plant_Code: "",
          Plant_Code: Plant_Code,
        };
        var data = JSON.stringify(requestInfo);
        //console.log(data);
        var config = {
          method: "post",
          url: apiURL + "MasterData/GetWasteRequestList",
          headers: {
            "Content-Type": "application/json",
          },
          data: data,
        };

        axios(config)
          .then((result) => {
            this.isLoading = false;
            if (result.data.status_code == 200) {
              var obj = result.data.response;
              var totrow = obj.length;
              var wasteData = [];
              for (var i = 0; i < totrow; i++) {
                var row = {
                  Request_ID: obj[i].Item_Id,
                  Date: obj[i].Request_Date,
                  Site_Name: obj[i].Site_Name,
                  Waste_Name: obj[i].Waste_Name,
                  Quantity: obj[i].Quantity,
                  Vehicle_Type: obj[i].Trucktype,
                  // ManifestNo: obj[i].ManifestNo,
                  action: "Edit",
                };
                //Status:obj[i].Request_Status,ETA:obj[i].Request_Time,
                wasteData.push(row);
              }
              this.items = wasteData;
            } else {
              /*self1.$swal.fire({
								  icon: 'error',
								  title: 'Oops...',
								  text: result.data.message		 
								})*/
              this.items = [];
            }
          })
          .catch((error) => {
            this.isLoading = false;
            this.$swal.fire({
              icon: "error",
              title: "Oops...",
              text: "Something went wrong!",
            });
          });
      } else {
        this.$swal.fire({
          icon: "error",
          title: "Oops...",
          text: result.data.message,
        });
      }
    });

    // .catch((error) => {
    //   this.isLoading = false;
    //   this.$swal.fire({
    //     icon: "error",
    //     title: "Oops...",
    //     text: "Something went wrong!",
    //   });
    // });
  },
  methods: {
    fnGetWastList() {
      // new API for getwast list
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      var requestInfo = {
        Token: token,
        Session_User_Id: Session_User_Id,
      };
      var data = JSON.stringify(requestInfo);
      console.log("data----", data);
      var newConfig = {
        headers: {
          "Content-Type": "application/json",
          "X-Requested-With": "X",
        },
        method: "get",
        //url: `http://180.179.23.81:8033/sap/opu/odata/sap/ZGOBOLT_MANIFEST_STATUS_SRV/GBLSHIPMENTSet(ItemId='1')`,
        data: data,
      };
      this.isLoading = true;
      axios(newConfig).then((result) => {
        if (result.data.status_code == 200) {
          var response = result.data.response;

          console.log("response----", response);
        } else {
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: result.data.message,
          });
        }
      });
      // .catch((error) => {
      //   this.isLoading = false;
      //   this.$swal.fire({
      //     icon: "error",
      //     title: "Oops...",
      //     text: "Something went wrong!",
      //   });
      // });
    },
    dateFilter_client() {
      console.log("date filter");
      this.getShuffledWasteDataFilter();
    },
    getShuffledWasteDataFilter() {
      console.log("call on load");
      var value = $("#plantcodeOptions").val();
      var siteOptionsArr = this.siteArr;
      var self = this;
      var Plant_Code = "";
      var selArr = siteOptionsArr.find(function (jsonitem, i) {
        if (value == jsonitem.Plant_Name) {
          Plant_Code = jsonitem.Plant_Code;
          //console.log(Plant_Code);
        }
      });

      var firstdate = $("#clientvise_fromdate").val();
      var today = $("#clientvise_todate").val();
      var token = localStorage.getItem("auth");
      var Session_User_Id = JSON.parse(localStorage.getItem("User_Id"));
      // for dashboard Api call
      const requestPaymentInfo = {
        customerID: Session_User_Id,
        plantCode: Plant_Code,
        type: "Summary",
        fromDate: firstdate,
        toDate: today,
      };
      var DashBoardInfodata = JSON.stringify(requestPaymentInfo);
      const newConfig = {
        method: "POST",
        url: apiURL + "Customer/DashBoardInfo",
        headers: { "Content-Type": "application/json" },
        data: DashBoardInfodata,
      };

      this.isLoading = true;
      axios(newConfig)
        .then((result) => {
          this.requestData = result.data.response;
          // for Ageing chart---------------------------------------
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
      // for wastrequest list data
      var requestInfo = {
        Token: token,
        RequestFromDate: firstdate,
        RequestToDate: today,
        Session_User_Id: Session_User_Id,
        Plant_Code: Plant_Code,
      };
      var data = JSON.stringify(requestInfo);
      //console.log(data);
      var config = {
        method: "post",
        url: apiURL + "MasterData/GetWasteRequestList",
        headers: {
          "Content-Type": "application/json",
        },
        data: data,
      };
      var self = this;
      this.isLoading = true;
      axios(config)
        .then((result) => {
          this.isLoading = false;
          if (result.data.status_code == 200) {
            var obj = result.data.response;
            var totrow = obj.length;
            var wasteData = [];
            for (var i = 0; i < totrow; i++) {
              var row = {
                Request_ID: obj[i].Item_Id,
                Date: obj[i].Request_Date,
                Site_Name: obj[i].Site_Name,
                Waste_Name: obj[i].Waste_Name,
                Quantity: obj[i].Quantity,
                Vehicle_Type: obj[i].Trucktype,
                // ManifestNo: obj[i].ManifestNo,
                action: "Edit",
              };
              wasteData.push(row);
            }
            this.items = wasteData;
          } else {
            /*self.$swal.fire({
						  icon: 'error',
						  title: 'Oops...',
						  text: result.data.message		 
						})*/
            this.items = [];
          }
        })
        .catch((error) => {
          this.isLoading = false;
          this.$swal.fire({
            icon: "error",
            title: "Oops...",
            text: "Something went wrong!",
          });
        });
    },

    shuffleArray(array) {
      for (let i = array.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = array[i];
        array[i] = array[j];
        array[j] = temp;
      }
      return array;
    },
    add() {
      //console.log('add');
      this.$router.push({ path: "add_waste" });
    },
  },
};
</script>
